/* eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'assignment-file',
  components: {},
  props: ['assignmentfileID'],
  data() {
    return {
      submitted: false,
      uploadFileName: '',
      assignment: '',
      file: null,
      name: '',
      description: '',
      index: ''
    }
  },
  computed: {},
  mounted() {
    console.log(this.assignmentfileID)
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('HideAddNewAssignmentPopup', false)
      }).catch((err) => {})
    },
    popupCloseFun() {
      bus.$emit('HideAddNewAssignmentPopup', false)
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.files = this.$refs.file.files[0];
      this.filesSize = this.$refs.file.files[0].size;
      if (this.$refs.file.files[0].size > 100000000) {
        alert('file size is exceed');
        this.name = ''
        this.uploadFileName = ''
      } else {
        this.name = this.files.name;
        this.uploadFileName = this.files.name
        console.log(this.name, this.filesSize);
      }
    },
    resetFileBefore() {
      this.uploadFileName = ''
    },
    validateAssignmentBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let formData = new FormData();
          formData.append('assignment', this.assignmentfileID);
          formData.append('file', this.files);
          formData.append('name', this.name);
          formData.append('description', this.description);
          formData.append('index', '1');
          this.$store.dispatch('addAssignmentFileFun', formData)
            .then((res) => {
              if (res.status == '201') {
                this.getCourseDetailsAgain();
                this.assignment = '';
                this.name = '';
                this.description = '';
                this.files = '';
                this.file = null;
                console.log(res.data.data.id)
                toast.success(res.data.msg);
                this.$validator.reset();
              }
            })
            .catch((err) => {})
          return
        }
      });
    },
  }
}